
import React, { useEffect, useState } from 'react';
import './Carousel.css';

const slides = [
  {
    title: "Eco-Friendly Excellence",
    desc: "Discover our premium collection of 100% recyclable paper bags, crafted with sustainability at heart.",
    cta: "Shop Now",
    className: "slide-1"
  },
  {
    title: "Custom Branding Solutions",
    desc: "Elevate your brand with our customizable paper bags. Perfect for retail, events, and corporate gifts.",
    cta: "Customize",
    className: "slide-2"
  },
  {
    title: "Bulk Orders Welcome",
    desc: "Special pricing for wholesale orders. Perfect for businesses looking for cost-effective packaging solutions.",
    cta: "Get Quote",
    className: "slide-3"
  },
  {
    title: "Certified Quality",
    desc: "All our products meet international quality standards. FSC certified and biodegradable materials only.",
    cta: "Learn More",
    className: "slide-4"
  },
  {
    title: "Fast Worldwide Shipping",
    desc: "Quick delivery to your doorstep. Free shipping on orders over $50. Track your order in real-time.",
    cta: "Order Now",
    className: "slide-5"
  }
];

const Carousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="carousel-container">
      <div className="carousel" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
        {slides.map((slide, idx) => (
          <div className={`slide ${slide.className}`} key={idx}>
            <div className="slide-content">
              <h2>{slide.title}</h2>
              <p>{slide.desc}</p>
              <a href="#products" className="cta-button">{slide.cta}</a>
            </div>
          </div>
        ))}
      </div>
      <div className="carousel-nav">
        {slides.map((_, idx) => (
          <div
            key={idx}
            className={`nav-dot ${currentSlide === idx ? 'active' : ''}`}
            onClick={() => setCurrentSlide(idx)}
          />
        ))}
      </div>
    </section>
  );
};

export default Carousel;
